export const animeTopics = [
  {
    id: "topic-1",
    title: "夏季热门动漫",
    subtitle: "当季讨论度最高的新番与续作，一网打尽",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20stylized%20summer%20illustration%20of%20anime%20characters%20silhouettes%20against%20a%20colorful%20fireworks%20night%20sky%20with%20festival%20lanterns%2C%20vibrant%20warm%20palette%2C%20painterly%20style%2C%20no%20text&width=800&height=560&seq=topic-01&orientation=landscape",
    count: 24,
  },
  {
    id: "topic-2",
    title: "经典回顾专题",
    subtitle: "值得反复重温的十年神作合辑",
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20stylized%20illustration%20of%20stacked%20old%20film%20reels%20and%20glowing%20retro%20television%20in%20a%20dark%20cozy%20room%2C%20warm%20amber%20and%20deep%20blue%20tones%2C%20painterly%20style%2C%20no%20text&width=800&height=560&seq=topic-02&orientation=landscape",
    count: 36,
  },
  {
    id: "topic-3",
    title: "剧场版大盘点",
    subtitle: "适合大银幕沉浸体验的动画电影精选",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20stylized%20illustration%20of%20a%20grand%20movie%20theater%20with%20a%20glowing%20screen%20and%20red%20seats%2C%20warm%20golden%20and%20deep%20red%20tones%2C%20painterly%20style%2C%20no%20text&width=800&height=560&seq=topic-03&orientation=landscape",
    count: 18,
  },
  {
    id: "topic-4",
    title: "国产动画崛起",
    subtitle: "原创与改编并进的国漫新势力",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20stylized%20illustration%20of%20an%20eastern%20fantasy%20city%20with%20floating%20mountains%20and%20teal%20mist%2C%20ink%20wash%20inspired%20digital%20art%2C%20muted%20green%20and%20gold%20palette%2C%20no%20text&width=800&height=560&seq=topic-04&orientation=landscape",
    count: 21,
  },
];